import { Box, FilterMenuCheckbox } from '@gassan-ui'
import { Item } from '@lib/kontent'
import { BrandPage } from '@lib/kontent/models/BrandPage'
import { StoreService } from '@lib/kontent/models/StoreService'
import { useTranslation } from 'next-i18next'
import React, { FC } from 'react'
import { FilterAction, FilterState } from '../reducer'

type Props = {
  dispatch: React.Dispatch<FilterAction>
  brands?: Item<BrandPage>[]
  services?: Item<StoreService>[]
  filters: FilterState
}

const FilterBar: FC<Props> = ({ dispatch, brands, services, filters }) => {
  const {
    t,
    i18n: { language },
  } = useTranslation(['other', 'stores'])
  return (
    <Box alignItems="center" display={{ _: 'none', large: 'flex' }}>
      <FilterMenuCheckbox
        lang={language}
        items={[
          {
            value: 'netherlands',
            label: t('netherlands', { ns: 'stores' }),
          },
          {
            value: 'singapore',
            label: 'Singapore',
          },
        ]}
        label={t('country', { ns: 'stores' })}
        activeFilters={filters.country.length}
        value={filters.country}
        onSelectItem={(value) => {
          dispatch({ type: 'set-filter', key: 'country', value: value as string[] })
        }}
        onClickReset={() => dispatch({ type: 'reset-filter', key: 'country' })}
      ></FilterMenuCheckbox>
      <FilterMenuCheckbox
        lang={language}
        items={[
          {
            value: 'opened-now',
            label: t('opendNow', { ns: 'stores' }),
          },
          {
            value: 'opened-evening',
            label: t('opendEvening', { ns: 'stores' }),
          },
          {
            value: 'opened-sunday',
            label: t('opendSunday', { ns: 'stores' }),
          },
        ]}
        label={t('openingHours', { ns: 'stores' })}
        activeFilters={filters.opened.length}
        value={filters.opened}
        onSelectItem={(value) => {
          dispatch({ type: 'set-filter', key: 'opened', value: value as string[] })
        }}
        onClickReset={() => dispatch({ type: 'reset-filter', key: 'opened' })}
      ></FilterMenuCheckbox>
      <FilterMenuCheckbox
        lang={language}
        items={services.map((service) => ({
          value: service.system.codename,
          label: service.elements.title.value,
        }))}
        label="Services"
        activeFilters={filters.services.length}
        value={filters.services}
        onSelectItem={(value) => {
          dispatch({ type: 'set-filter', key: 'services', value: value as string[] })
        }}
        onClickReset={() => dispatch({ type: 'reset-filter', key: 'services' })}
      ></FilterMenuCheckbox>
      <FilterMenuCheckbox
        hasSearch
        placeholder={t('searchBrands', { ns: 'other' })}
        noneFoundText={t('noBrandsFound', { ns: 'other' })}
        label={t('brands', { ns: 'other' })}
        activeFilters={filters.brands.length}
        items={brands.map((brand) => ({
          value: brand.system.codename,
          label: brand.elements.title.value,
        }))}
        value={filters.brands}
        onSelectItem={(value) =>
          dispatch({ type: 'set-filter', key: 'brands', value: value as string[] })
        }
        onClickReset={() => dispatch({ type: 'reset-filter', key: 'services' })}
      />
    </Box>
  )
}

export default FilterBar
